// extracted by mini-css-extract-plugin
export default {"container":"Skills_container__5+yxw","group":"Skills_group__Q0xHh","groupLabel":"Skills_groupLabel__hIhpu","pills":"Skills_pills__wChkG"};